import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301) till /ai. */
export const Route = createFileRoute("/elmarknad-ai")({
  beforeLoad: () => permanentRedirect("/ai"),
});
